'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of glucometer
 */ const Glucometer = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3477_3633)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M67.6649 21.0527H36.1913C31.3564 21.0527 27.4375 24.9716 27.4375 29.8066V65.8451C27.4375 74.1311 34.1551 80.8518 42.4442 80.8518H45.2357V74.6659C45.2357 72.5957 46.9174 70.9139 48.9877 70.9139H54.8727C56.9429 70.9139 58.6246 72.5957 58.6246 74.6659V80.8518H61.4161C69.7021 80.8518 76.4228 74.1311 76.4228 65.8451V29.8066C76.4228 24.9716 72.5039 21.0527 67.6659 21.0527H67.6649ZM43.3263 64.4869C43.3263 65.503 42.504 66.3263 41.4869 66.3263H37.6319C36.6159 66.3263 35.7925 65.504 35.7925 64.4869V60.6319C35.7925 59.619 36.6148 58.7926 37.6319 58.7926H41.4869C42.5029 58.7926 43.3263 59.618 43.3263 60.6319V64.4869ZM55.695 64.4869C55.695 65.503 54.8727 66.3263 53.8556 66.3263H50.0006C48.9877 66.3263 48.1653 65.504 48.1653 64.4869V60.6319C48.1653 59.619 48.9877 58.7926 50.0006 58.7926H53.8556C54.8716 58.7926 55.695 59.618 55.695 60.6319V64.4869ZM68.0668 64.4869C68.0668 65.503 67.2403 66.3263 66.2274 66.3263H62.3724C61.3563 66.3263 60.533 65.504 60.533 64.4869V60.6319C60.533 59.619 61.3553 58.7926 62.3724 58.7926H66.2274C67.2403 58.7926 68.0668 59.618 68.0668 60.6319V64.4869ZM69.0364 52.38C69.0364 53.3527 68.2471 54.1421 67.2743 54.1421H36.5829C35.6101 54.1421 34.8208 53.3527 34.8208 52.38V30.4619C34.8208 29.4892 35.6101 28.6998 36.5829 28.6998H67.2743C68.2471 28.6998 69.0364 29.4892 69.0364 30.4619V52.38Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M54.872 73.5918H48.988C48.3927 73.5918 47.9102 74.0744 47.9102 74.6697V89.0313C47.9102 89.6266 48.3927 90.1092 48.988 90.1092H54.872C55.4673 90.1092 55.9499 89.6266 55.9499 89.0313V74.6697C55.9499 74.0744 55.4673 73.5918 54.872 73.5918Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M52.7358 32.7737C52.5514 32.5141 52.2515 32.3574 51.9331 32.3574C51.6147 32.3574 51.3148 32.5141 51.1293 32.7737C50.5677 33.5693 45.6328 40.6506 45.6328 44.18C45.6328 47.7093 48.4594 50.4792 51.9331 50.4792C55.4068 50.4792 58.2313 47.6537 58.2313 44.18C58.2313 40.7063 53.2985 33.5693 52.7358 32.7737Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3477_3633",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "48.9853",
                        height: "69.0526",
                        fill: "white",
                        transform: "translate(27.4375 21.0527)"
                    })
                })
            })
        ]
    });
};

exports.Glucometer = Glucometer;
//# sourceMappingURL=Glucometer.cjs.map
